import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "top-bar" }
const _hoisted_2 = { class: "middle-menu" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "right-others" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_popover = _resolveComponent("el-popover")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tapBarList, (item, index) => {
        return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
          (item.event === 'click')
            ? (_openBlock(), _createBlock(_component_el_button, {
                key: 0,
                type: "text",
                class: _normalizeClass(["menu-item-btn", item.name === _ctx.curMenu ? 'active' : '']),
                onClick: ($event: any) => (_ctx.selectMenu(item.name))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(item.label), 1)
                ]),
                _: 2
              }, 1032, ["class", "onClick"]))
            : _createCommentVNode("", true),
          (item.event === 'hover')
            ? (_openBlock(), _createBlock(_component_el_popover, {
                key: 1,
                placement: "bottom-start",
                "popper-class": "menu-popover",
                width: "100",
                trigger: "click"
              }, {
                reference: _withCtx(() => [
                  _createVNode(_component_el_button, {
                    type: "text",
                    class: _normalizeClass(["menu-item-btn", item.name === _ctx.curMenu ? 'active' : ''])
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(item.label), 1)
                    ]),
                    _: 2
                  }, 1032, ["class"])
                ]),
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.hover.content, (o) => {
                    return (_openBlock(), _createElementBlock("div", { key: o }, [
                      _createVNode(_component_el_button, {
                        type: "text",
                        onClick: ($event: any) => (_ctx.openCasePage(o.path))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(o.label), 1)
                        ]),
                        _: 2
                      }, 1032, ["onClick"])
                    ]))
                  }), 128))
                ]),
                _: 2
              }, 1024))
            : _createCommentVNode("", true)
        ], 64))
      }), 128))
    ]),
    _hoisted_3
  ]))
}